<!-- 2023 春季摄影 -->
<template>
<div class="spring2023">
    <SimpleHead />
    <div class="banner only-pc" style="background-image:url(https://media3.imgyb.xyz/media/v1/image/c973fb9afa1421c92e535a5cb27123e5.png)">
        <div class="container"><img src="https://media3.imgyb.xyz/media/v1/image/54194d4be262e05c364d696dcf8c5c5a.png" alt=""></div>
        <div class="stack">
            <div class="container">

                <SpringIntroduction2023 class="only-pc" />
            </div>
        </div>
    </div>
    <div class="banner only-mobile">
        <img src="https://media4.imgyb.xyz/media/v1/image/be13de148e0a2419dc12b6b207561a21.jpeg" alt="">
    </div>
    <div class="container ">
        <SpringIntroduction2023 class="only-mobile" />
        <SpringRules2023 />

       <!--  <div><img src="https://media2.imgyb.xyz/media/v1/image/a70c12e294cfcea57cf9b738561e64d5.png" alt=""></div> -->
        <div class="tab">
            <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选推荐</div>
         
            <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
        </div>
        <div class="post-list" v-if="list.length>0">
            <template v-for="(item,index) in list" >
                <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index"></YorkbbsInfoflowItem>
                <div class="post-item" v-else :key="item.id"><SubjectPostItem  :data="item" @attention="attention" /></div>
                
            </template>

            
        </div>
        <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
        <div class="loading-style" v-if="!hasMore" >没有更多了</div>
    </div>
    <div class="white-space"></div>
    <CssFooter></CssFooter> 
    
    <div class="join-play">
        <div class="box">
            <a @click="postLink($event)" :href="'/publish/travel?subject=572cdf04-23e8-424e-9ef3-a03aad0443f9'|hostBuild('forum')" target="_blank"><div><i class="el-icon-camera-solid"></i></div> 参与话题</a>
            <!-- <a @click="postLink($event)" href="javascript:void(0)"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a> -->
        </div>

    </div>
</div>
</template>
<script>
import SimpleHead from '@/components/widgets/simple-head.vue'
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import { throttle } from 'throttle-debounce';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
import SpringIntroduction2023 from './introduction.vue'
import SpringRules2023 from './spring-rules.vue'
import SubjectPostItem from './subject-post-item.vue'
import CssFooter from '@/components/css-footer.vue'
export default {
    name:'SpringPhotograph2023',
    components:{SpringIntroduction2023,SpringRules2023,SimpleHead,YorkbbsInfoflowItem,SubjectPostItem,CssFooter},
    data(){
        return {
            type:0,
            params:{
                subjectIds:['572cdf04-23e8-424e-9ef3-a03aad0443f9'],
                dataOrigin:['bbs_post'],
                offset:1,
                size:10,
            },
           
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:false,
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_top: DESC','property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.hasMore = true;
            this.list = [];
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            
            if( this.params.offset == 1 ){
                this.list = [];
            }
            if( this.type == 0 ){
                let result = await this.$axios.post('/subject/v1/post/list/recommended/for/special',this.params);
    
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
                this.detail.postCount = result.data.itemTotal;
       
            }else{
                let result = await this.$axios.post('/subject/v1/post/list/latest/for/special',this.params);
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
             
            }
           

            this.pageComplete = true;
            this.listLoading = false;
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            /* let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            } */
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        postLink(event){
            console.log(event);
            try{
                
                flutterForumPost.postMessage(JSON.stringify({
                    topicId:'5238de03-c0cd-4aba-b8a3-d60e8987d11e',
                    subject:'572cdf04-23e8-424e-9ef3-a03aad0443f9',
                    name:'旅游'
                }))
                event.preventDefault()
                return false;
            }catch(err){
                return true;
            }
            
        },
        attention(obj){
            console.log(obj);
            for(var i=0; i<this.list.length;i++){
                if(this.list[i].app != 'bbs_post') continue;
                if( this.list[i].user.id == obj.id){
                    this.list[i].user.focusedByMe = obj.val;
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.spring2023{
    background: #DEEE74;
    .only-pc{display: none;}
    .only-mobile{display: none;}
    .banner{background: no-repeat center top;
        position: relative;
        .stack{
            position: absolute; left: 0; bottom: 0; right: 0;
        }
    }
    .container{
        width: 800px; margin: 0 auto;
    }
    .tab{
        display: flex; justify-content: center; margin: 35px 0 20px;
        .item{
            font-size: 20px; line-height: 36px; margin: 0 20px; user-select: none; cursor: pointer;
            &.active{
                color: #EA3276; font-size: 26px; font-weight: bold;
                background:linear-gradient(rgba(255,255,255,0) 0%,rgba(255,255,255,1) 75%,rgba(255,255,255,1) 100% )
            }
        }
    }
    .post-list{
        .post-item{
            padding: 20px 30px; background:#fff; border-radius: 8px; margin-bottom: 20px;
        }
    }
    .loading-style{display: flex; padding-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
        i{margin-right: 5px;}
    }
   /*  .join-play{
        position: fixed; z-index: 10; bottom: 80px; left: 50%; right: 0; width: 800px; margin-left: -400px;
        .box{
            display: flex;  align-items: center; justify-content: center; color: #fff; font-size: 20px; 
            background: linear-gradient(123deg,#ff6496 6%, #fa4a83 21%, #fa4a83 66%);

            height: 40px; user-select: none; cursor: pointer;
            font-size: 20px;  text-align: center;
            border-radius: 25px;
            i{font-size: 24px; margin-right: 5px;}
            a{display: flex; align-items: center;}
            &:hover{
                background: #f6354e; color: #fff;
            }
        }
    } */
    .white-space{height: 50px;}
}
@media screen and (min-width:768px){
    .spring2023{
        .only-pc{display: block;}
        .join-play{
            position: fixed; z-index: 10; bottom: 80px; left: 50%; right: 0; width: 800px; margin-left: -400px;
            .box{
                display: flex;  align-items: center; justify-content: center; color: #fff; font-size: 20px; 
                background: linear-gradient(123deg,#ff6496 6%, #fa4a83 21%, #fa4a83 66%);

                height: 40px; user-select: none; cursor: pointer;
                font-size: 20px;  text-align: center;
                border-radius: 25px;
                i{font-size: 24px; margin-right: 5px;}
                a{display: flex; align-items: center;}
                &:hover{
                    background: #f6354e; color: #fff;
                }
            }
        }
    }
}
@media screen and (max-width:768px){
    .spring2023{
        .only-mobile{display: block;}
        .container{
            width: 100%; box-sizing: border-box; padding: 0 15px; overflow: hidden;
        }
        .banner{
            .container{
                padding: 0;
            }
        }
        .join-play{
            position: fixed; z-index: 10; bottom: 150px;  right: 10px;
            .box{
                display: flex; flex-direction: column; align-items: center; justify-content: center; color: #fff; font-size: 20px; 
                background: linear-gradient(123deg,#ff6496 6%, #fa4a83 21%, #fa4a83 66%);

                width:76px; height: 76px; user-select: none; cursor: pointer;
                font-size: 12px; color: #fff; text-align: center;
                border-radius: 50%;
                i{font-size: 24px; margin-bottom: 3px;}
                &:hover{
                    background: #f6354e; color: #fff;
                }
            }
        }
        .white-space{
            height: 20px;
        }
        .post-list{
            .post-item{padding: 15px;}
        }
    }
}
</style>